<template>
  <div class="index" v-loading="loading" element-loading-text="加载中">
    <p v-for="(item,i) in data" :key="i">{{ item.create_time }}</p>
    <div class="kong" v-if="data.length == 0">暂无数据</div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  name: "index",
  props: ["activeName"],
  //组件引入
  components: {},
  //状态存储
  data() {
    return {
      loading: true,
      data: [],
    };
  },
  //计算属性
  computed: {},
  //状态监听
  watch: {
    activeName() {
      this.loading = true;
      this.getData();
    },
  },
  //存放方法集合
  methods: {
    handleClick() {
      this.getData();
    },
    getData() {
      console.log("登录");
      let obj = {
        user_detail_id: this.$route.query.id,
        day_week: this.activeName,
        show_data: "login",
      };
      require("POST", "/hr24_index_data/v1/user_data_detail/", obj).then(
        (res) => {
          if (!res.code) {
            this.loading = false;
            this.data = res.data[0].user_login_list;
          }
          console.log("res", res);
        }
      );
    },
  },
  //数据初始化之后
  created() {},
  //页面渲染之后
  mounted() {
    this.getData();
  },
  //数据初始化之前
  beforeCreate() {},
  //页面渲染之前
  beforeMount() {},
  //状态更新之前
  beforeUpdate() {},
  //状态更新之后
  updated() {},
  //页面卸载之前
  beforeDestroy() {},
  //卸载之后
  destroyed() {},
  //页面进入   页面缓存时有效
  activated() {},
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */

.index {
  padding: 60px 20px 20px;
  min-height: 400px;
}

.index > p {
  width: 80%;
  line-height: 30px;

  text-align: center;
  font-size: 14px;
  color: #fff;
  margin: 0 auto;
  border: #fff solid 2px;
  background: rgb(140, 174, 236);
}
.kong {
  text-align: center;
  line-height: 400px;
  color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/recruitmentData/index.vue